import type { RegistrationOption } from "@/types";
export type { RegistrationType } from "@/types";

export function registrationFormValues(event: {
  registrationOptions?: RegistrationOption[] | null;
  registrationNotes?: string | null;
  registrationType?: string | null;
  registrationValue?: string | null;
}): { registrationOptions: RegistrationOption[]; registrationNotes: string } {
  return {
    registrationOptions:
      event.registrationOptions != null
        ? event.registrationOptions.map((option) => ({ ...option }))
        : event.registrationType && event.registrationValue
          ? [
              {
                type: event.registrationType as RegistrationOption["type"],
                value: event.registrationValue,
                label: null,
                notes: null,
              },
            ]
          : [],
    registrationNotes: event.registrationNotes ?? "",
  };
}

export interface EventFormValues {
  title: string;
  eventDescription: string;
  date: string; // YYYY-MM-DD when isAllDay; otherwise datetime-local YYYY-MM-DDTHH:mm
  endDate: string;
  isAllDay: boolean;
  venueId: string;
  categoryId: string;
  detailsUrl: string;
  registrationOptions: RegistrationOption[];
  registrationNotes: string;
  source: string;
  sourceUrl: string;
  isPreview: boolean;
}

export function emptyEventFormValues(): EventFormValues {
  return {
    title: "",
    eventDescription: "",
    date: "",
    endDate: "",
    isAllDay: false,
    venueId: "",
    categoryId: "",
    detailsUrl: "",
    registrationOptions: [],
    registrationNotes: "",
    source: "",
    sourceUrl: "",
    isPreview: false,
  };
}
